var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-step--wrapper"},[_c('div',{staticClass:"form--content form-creator--step-5--content"},[_c('v-textarea',{attrs:{"outlined":"","name":"","placeholder":this.$t('message.forms.maxCharacters200')},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }